export const ALERT_TYPE = {
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error"
}